module.exports = __webpack_public_path__ + "static/media/07.Homa Havana.aa5b4d9c.jpg";